module.exports = __webpack_public_path__ + "static/media/crane.ef981d1d.svg";